<template>
  <nav id="top-nav" ref="topNav" class="cl-nav">
    <v-container class="cl-header pa-0 d-flex justify-space-between">
      <MegaMenu></MegaMenu>
      <div
        v-if="$vuetify.display.smAndDown"
        class="mobile-menu-items d-flex w-100 justify-content-between px-4"
      >
        <div>
          <a id="mobile-menu-btn" @click="openMenu" class="button-collapse">
            <v-icon>
              <img src="@/assets/images/main_page/icons/menu.svg" />
            </v-icon>
          </a>
          <router-link :to="{ name: 'home' }" class="logo-classino mr-4" append>
            <img
              src="@/assets/images/logo/classinoLogo.svg"
              alt="لوگو کلاسینو - Classino logo"
              width="121"
              height="38"
            />
          </router-link>
        </div>

        <div class="d-flex justify-center align-center">
          <button
            id="mobile-search-btn"
            @click="toggleMobileSearch"
            class="mobile-search-btn mr-3"
            aria-label="Search button"
          >
            <v-icon><img src="@/assets/images/main_page/icons/search.svg" alt="Search" /></v-icon>
          </button>

          <v-btn
            width="110px"
            variant="flat"
            :href="this.$studentBaseUrl"
            class="rounded-lg mr-2 text-decoration-none"
            style="letter-spacing: 0"
            color="primary"
          >
            ورود/ثبت‌ نام
          </v-btn>
        </div>
      </div>
      <v-spacer />
      <div
        class="d-flex align-center justify-space-between px-4"
        v-if="!$vuetify.display.mdAndDown"
        style="width: 35%"
      >
        <DesktopSearch />

        <v-btn
          variant="flat"
          :href="this.$studentBaseUrl"
          class="rounded-lg text-decoration-none"
          style="letter-spacing: 0"
          color="primary"
        >
          ورود/ثبت‌ نام
        </v-btn>
      </div>

      <MobileHeaderMenu></MobileHeaderMenu>
      <MobileSearch
        :activeSearchModal="isActiveMobileSearch"
        @mobileSearchBtnTrigger="isActiveMobileSearch = !isActiveMobileSearch"
      />
    </v-container>
    <LiveClassBanner></LiveClassBanner>
  </nav>
</template>

<script>
import DesktopSearch from '@/components/search/DesktopSearch.vue'
// import DesktopMenu from "@/layouts/DesktopMenu.vue";
import MobileHeaderMenu from '@/layouts/MobileHeaderMenu.vue'
import MobileSearch from '@/components/search/MobileSearch.vue'
import MegaMenu from '@/components/layouts/mega-menu/MegaMenu.vue'
import LiveClassBanner from '@/components/home/LiveClassBanner.vue'
// import Login from "@/components/auth/Login";

export default {
  name: 'TopNavbar',
  components: {
    LiveClassBanner,
    MegaMenu,
    MobileSearch,
    DesktopSearch,
    // DesktopMenu,
    MobileHeaderMenu
  },
  data() {
    return {
      menu: '',
      menuItems: '',
      mobileMenuItems: '',
      isActiveMobileSearch: false,
      isActiveMobileDrawer: false,
      spinnerInterval: '',
      transparentMenu: false,
      staticMenu: false,
      isActiveLogin: false,
      menuOffsetTop: '',
      isHidden: false,
      routeName:'',
      lastScrollY: 0
    }
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    if (this.$router.currentRoute.name === 'course') {
      this.staticMenu = true
    }
    this.menuOffsetTop = this.$refs.topNav.offsetTop
  },
  methods: {
    handleScroll() {
      const currentScrollY = window.scrollY
      this.isHidden = currentScrollY > this.lastScrollY
      this.lastScrollY = currentScrollY
    },
    openMenu() {
      this.$store.dispatch('mobileMenu/openMenu')
    },
    toggleMobileSearch() {
      this.isActiveMobileSearch = !this.isActiveMobileSearch
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
#mobile-menu-btn {
  display: flex;
  align-items: center;
  height: 100%;
}
.hidden {
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.3s;
}
#mobile-menu-btn .spinner-border {
  width: 1.7rem;
  height: 1.7rem;
}
.new-cta-panel {
  padding: 17px !important;
  font-size: 15px !important;
  @include media-breakpoint-down(md) {
    width: 90%;
  }
}
.new-cta-panel-test {
  padding: 17px !important;
  font-size: 15px !important;
  @include media-breakpoint-down(md) {
    width: 90%;
  }
}
.mm-wrapper_blocking {
  overflow: hidden !important;
}
</style>
